var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrdrio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "text-Light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 157,
    height: 26,
    viewBox: "0 0 157.26 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71444",
    "data-name": "Group 71444",
    transform: "translate(-66 -1031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70605",
    "data-name": "Group 70605",
    transform: "translate(122 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(26.991 1044.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M18.97,19.958c.068-3.2,0-6.479,0-9.69a11.175,11.175,0,0,0-.521-4.328C16.139-.5,7.829-2,2.952,2.9A9.989,9.989,0,0,0,3.935,17.92c3.2,2.492,6.325,2.045,10.131,2.045,1.613,0,3.3.048,4.9-.006Z",
    transform: "translate(0 0)",
    fill: "#b4b4b4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M146.541,135.152v-6.127h7.484v6.127a.313.313,0,0,1-.039.155.285.285,0,0,1-.1.019h-7.213a.285.285,0,0,1-.1-.019.313.313,0,0,1-.039-.155Zm4.052-8.59h2.055a1.432,1.432,0,0,0,.13.239c.049.082.09.149.135.233.115.21.782,1.327.8,1.409h-3.122Zm-2.676,0h2.075v1.881h-3.141l.263-.474c.1-.161.173-.3.269-.468s.18-.3.27-.467c.049-.09.247-.4.265-.472Zm-1.958,2.365v6.36a.7.7,0,0,0,.621.621h7.407a.7.7,0,0,0,.621-.621v-6.418a3.245,3.245,0,0,0-.4-.782c-.074-.135-.149-.25-.22-.381l-.887-1.517a.581.581,0,0,0-.393-.208h-4.848c-.327,0-.484.345-.619.583-.149.261-.3.518-.446.776l-.438.764a2.476,2.476,0,0,0-.4.825Z",
    transform: "translate(-140.118 -120.947)",
    fill: "#f0f4f8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M220.228,256.227c-.282-.189-.391-.562-.756-.562a.3.3,0,0,0-.252.291c0,.162.2.308.3.4l.349.349c.119.119.215.282.42.238.149-.032.292-.223.394-.325l1.047-1.047c.095-.095.305-.249.305-.412a.317.317,0,0,0-.161-.266c-.278-.135-.474.174-.765.465l-.436.436a5.111,5.111,0,0,1-.441.432Z",
    transform: "translate(-210.451 -244.679)",
    fill: "#f0f4f8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M543.737,100.816a5.032,5.032,0,1,0-5.227-5.039A4.955,4.955,0,0,0,543.737,100.816Zm0-2.242a2.8,2.8,0,1,1,2.542-2.8A2.551,2.551,0,0,1,543.737,98.575Zm9.5,2V94.25a3.362,3.362,0,0,1,2.439-1.091,3.438,3.438,0,0,1,.717.06v-2.46a4.394,4.394,0,0,0-3.157,1.527V91h-2.6v9.581h2.6Zm13.909,0V87.347h-2.624v4.88a3.8,3.8,0,0,0-3.054-1.468c-2.521,0-4.386,1.9-4.386,5.019,0,3.213,1.906,5.039,4.386,5.039a3.86,3.86,0,0,0,3.054-1.468v1.23h2.624Zm-4.858-2a2.8,2.8,0,0,1,0-5.574,2.854,2.854,0,0,1,2.234,1.091v3.392A2.854,2.854,0,0,1,562.291,98.575Zm9.749,2V94.25a3.362,3.362,0,0,1,2.439-1.091,3.439,3.439,0,0,1,.717.06v-2.46a4.392,4.392,0,0,0-3.156,1.527V91h-2.6v9.581h2.6Zm5.772-10.613a1.533,1.533,0,0,0,1.558-1.507,1.548,1.548,0,1,0-1.558,1.507Zm1.312,10.613V91h-2.6v9.581Zm6.879.238a5.032,5.032,0,1,0-5.227-5.039A4.955,4.955,0,0,0,586,100.816Zm0-2.242a2.8,2.8,0,1,1,2.542-2.8A2.551,2.551,0,0,1,586,98.575Z",
    transform: "translate(-516.981 -83.496)",
    fill: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Powered_by",
    "data-name": "Powered by",
    transform: "translate(-56 1059)",
    fill: "#b4b4b4",
    fontSize: 13,
    fontWeight: 300,
    letterSpacing: "0.036em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\r\n                    Powered by\r\n                  "))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdrio);
export default __webpack_public_path__ + "static/media/Ordrio.80d66ecce695127ea51e298082bff5c3.svg";
export { ForwardRef as ReactComponent };